































































import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'
import BrandContextMixin from '../../../mixins/brandContext'
import LoadingMixin, { Status } from '../../../mixins/loading'
import { PluginMixin } from '../../../mixins/plugin'

import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import ApiBrand from '@/models/api/brand'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import MycolorItems from '@spa/components/organisms/mypage/MyColorItems.vue'

@Component({
  components: {
    MycolorItems,
    SpaErrorDialog,
  },
  mixins: [
    LoadingMixin,
    BrandContextMixin,
  ],
})
export default class MyColorItems extends Mixins<PluginMixin & BrandContextMixin>(PluginMixin, BrandContextMixin) {

  Status = Status
  status: Status = Status.Pending
  showModal: boolean = false
  modalMessage: string = ''
  behaviorConfig = new BehaviorConfig()
  brands: ApiBrand[] = []

  get topUrl(): string {
    return this.$store.state.history.urlToContinueShopping || '/'
  }

  get errorOnLoad() {
    return _.get(this.$store.state.user, 'error.load')
  }

  get isLoading(): boolean {
    return this.status === Status.Loading
  }

  get isPageCompleted(): boolean {
    return this.status === Status.Completed
  }

  async created() {
    this.status = Status.Loading
    await Promise.all([
      this.initOrElseRedirectUser(),
      this.initBrandList(),
      this.$store.dispatch('history/setUrlToContinueShopping'),
    ])
    this.setUpBrand()
    this.status = Status.Completed
  }

  async initOrElseRedirectUser(): Promise<void> {

    // Load User
    await this.$store.dispatch('user/get', { force: true })

    const user = this.$store.state.user.user

    if (!user) {
      this.modalMessage = 'ログインできませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
      this.showModal = true

      this.$router.push('/login')

      return
    }

    // other
    if (this.errorOnLoad) {
      this.modalMessage = 'お客様情報が取得できませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
      this.showModal = true

      this.status = Status.Failed

      return
    }
  }

  private setUpBrand() {
    this.brands = this.allBrands

    if (this.initialBrand === null) {
      return
    }

    this.brands = this.transferableBrands(this.initialBrand)
  }
}
